var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:!_vm.$store.state.clientConfig.logo.usePrimaryBg ? 'nonTransparent' : 'transparent'},[_c('div',{staticClass:"loader-wrapper"},[_c('img',{attrs:{"src":`${_vm.$store.state.clientConfig.directoryUrl}/img/logo.png`}}),_c('div',{staticClass:"loading"}),_c('h5',[_vm._v(_vm._s(_vm.loadingText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }